import { computed, ref, watch, type Ref } from 'vue'

type PaymentMethod = 'cash' | 'card' | 'digital' | 'other'

interface UseOrderPaymentStateOptions {
  isPosOnlyMode: Ref<boolean>
  modeLoaded: Ref<boolean>
  orderTotal: Ref<number>
}

export function useOrderPaymentState(options: UseOrderPaymentStateOptions) {
  const markAsPaid = ref(false)
  const selectedPaymentMethod = ref<PaymentMethod>('cash')
  const cashReceived = ref(0)

  watch(
    [options.isPosOnlyMode, options.modeLoaded],
    ([isPOS, loaded]) => {
      if (loaded && isPOS) {
        markAsPaid.value = true
      }
    },
    { immediate: true }
  )

  const isPaymentValid = computed(() => {
    if (!markAsPaid.value) {
      return true
    }

    if (selectedPaymentMethod.value === 'cash') {
      return cashReceived.value >= options.orderTotal.value
    }

    return true
  })

  return {
    markAsPaid,
    selectedPaymentMethod,
    cashReceived,
    isPaymentValid
  }
}
